import { useContext, useEffect, useState } from 'react';
import { Helmet } from 'react-helmet-async';

import axios from 'axios';
import { Link } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { GeneralContext } from '../../../context/generalContext';
import { AboutContext } from '../../../context/aboutContext';
import { getBaseUrl } from '../../../functions/getBaseUrl';
import FormSelect from '../../../Components/Form/Select/FormSelect';
import FormInputText from '../../../Components/Form/InputText/FormInputText';
import FormInputPhone from '../../../Components/Form/InputPhone/FormInputPhone';
import FormInputEmail from '../../../Components/Form/InputEmail/FormInputEmail';
import FormInputFile from '../../../Components/Form/InputFile/FormInputFile';
import MessageModal from '../../../Components/Form/MessageModal/MessageModal';

import classesForm from '../../../Components/Form/Form.module.scss';
import classes from './AboutVacancies.module.scss';

export default function AboutVacancies() {
  const { setActiveSection } = useContext(AboutContext);
  const { path, activeLanguage, activeCity } = useContext(GeneralContext);
  // при изменении path проверяем в каком разделе находимся в данный момент и устанавливаем активный раздел
  useEffect(() => {
    if (path.slice(-7) === 'vacancy') {
      setActiveSection(5);
    }
  }, [path]);

  const waiter = activeLanguage === 1 ? 'Официант' : 'Waiter';
  const cavist = activeLanguage === 1 ? 'Специалист по напиткам' : 'Сavist';
  const hostess = activeLanguage === 1 ? 'Хостес' : 'Hostess';
  const cook = activeLanguage === 1 ? 'Повар' : 'Cook';
  const other = activeLanguage === 1 ? 'Другая вакансия' : 'Other';
  const vacanciesOptions = [
    { value: 'waiter', label: waiter },
    { value: 'cavist', label: cavist },
    { value: 'hostess', label: hostess },
    { value: 'cook', label: cook },
    { value: 'other', label: other },
  ];

  // Схема для валидации
  const [phonePattern, setPhonePattern] = useState(null);
  useEffect(() => {
    activeCity === 6
      ? setPhonePattern(/^((\+998)(\s)([0-9]{2})(\s)([0-9]{3})-([0-9]{2})-([0-9]{2}))$/)
      : setPhonePattern(/^((\+7)(\s)([0-9]{3})(\s)([0-9]{3})-([0-9]{2})-([0-9]{2}))$/);
  }, [activeCity]);
  const schema = yup.object().shape({
    education: yup.string().required(activeLanguage === 1 ? 'Обязательное поле' : 'Required field'),
    languagesSkill: yup.string().required(activeLanguage === 1 ? 'Обязательное поле' : 'Required field'),
    workExperience: yup.string().required(activeLanguage === 1 ? 'Обязательное поле' : 'Required field'),
    FIO: yup.string().required(activeLanguage === 1 ? 'Обязательное поле' : 'Required field'),
    phone: yup
      .string()
      .required(activeLanguage === 1 ? 'Обязательное поле' : 'Required field')
      .matches(phonePattern, activeLanguage === 1 ? 'Введите корректный номер' : 'Please enter a valid number'),
    email: yup.string().email(activeLanguage === 1 ? 'Введите корректный Email' : 'Please enter a valid email'),
  });

  // модули для react-hook-form
  const {
    control,
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({
    mode: 'onChange',
    resolver: yupResolver(schema),
    defaultValues: {
      vacancy: vacanciesOptions[0],
      phone: '',
      userPhoto: [],
      userResume: [],
    },
  });

  // хуки для загружаемых файлов
  const [userPhoto, setUserPhoto] = useState([]);
  const [userPhotoError, setUserPhotoError] = useState('');
  /// /////////////////////////////////////////
  const [userResume, setUserResume] = useState([]);
  const [userResumeError, setUserResumeError] = useState('');

  // хук для индикации загрузки
  const [isLoading, setIsLoading] = useState(false);

  // хук для сообщений
  const [showMessage, setShowMessage] = useState(false);
  const [showErrorMessage, setShowErrorMessage] = useState(false);
  const openMessage = () => {
    // disableBodyScroll(true);
    document.body.style.overflow = 'hidden';
    document.body.style.position = 'fixed';
    document.body.style.width = '100%';
    setShowMessage(true);
  };
  const openErrorMessage = () => {
    // disableBodyScroll(true);
    document.body.style.overflow = 'hidden';
    document.body.style.position = 'fixed';
    document.body.style.width = '100%';
    setShowErrorMessage(true);
  };
  const closeMessage = () => {
    // enableBodyScroll(true);
    document.body.style.overflow = 'visible';
    document.body.style.position = '';
    document.body.style.width = '';
    setShowMessage(false);
    setShowErrorMessage(false);
  };
  const message = {
    title: 'Ваша анкета принята',
    title_en: 'Your application has been accepted',
    text: 'Мы&nbsp;взяли в&nbsp;обработку ваши данные. Спасибо!',
    text_en: 'We&nbsp;will process your data. Thank you!',
    errorText: 'Сервер временно недоступен, пожалуйста, повторите запрос позже.',
    errorText_en: 'The server is&nbsp;temporarily unavailable, please try again later.',
  };

  // получаем куку cm_data
  // let cm_data
  // const cmDataCookie = cookies[0].cm_data
  // cmDataCookie ? cm_data = cmDataCookie : cm_data = ''

  const [cmData, setCmData] = useState('');
  const [count, setCount] = useState(0);
  useEffect(() => {
    const credentials = window.Comagic?.getCredentials();
    let _cm_data = '';
    for (const field in credentials) {
      console.log('field', field);
      console.log('credentials[field]', credentials[field]);
      if (field === 'consultant_server_url') {
        continue;
      }

      // Если в объекте CoMagic нет определённого свойства, то запускаем новую попытку
      if (!credentials.hasOwnProperty(field)) {
        // throw new Error('has no property');
        _cm_data = '';
        setCmData(_cm_data);
        break;
      }

      // Если определённое свойство CoMagic не заполненно данными, то запускаем новую попытку
      if (!credentials[field]) {
        // throw new Error('has no value');
        _cm_data = '';
        setCmData(_cm_data);
        break;
      }

      _cm_data += `${field}#${credentials[field]}|`;
    }
    setCmData(_cm_data);
    console.log('_cm_data, count', _cm_data, count);
    if (_cm_data === '' && cmData === '') {
      const timer = setTimeout(() => setCount(count + 1), 5000);
      return () => clearTimeout(timer);
    }
  }, [count, cmData]);
  console.log('cmDataVacancies', cmData);

  // обработка сабмита
  const onSubmit = data => {
    data.formName = 'vacancyApp';
    data.cm_data = cmData;
    const dataLayer = [];

    // получаем фото пользователя
    if (userPhoto[0]) {
      data.userPhoto = userPhoto[0];
    }

    // получаем резюме пользователя
    if (userResume[0]) {
      data.userResume = userResume[0];
    }

    const formData = new FormData();
    Object.entries(data).map(([key, value]) => {
      let curValue = value;
      typeof curValue === 'object' && key === 'vacancy' ? (curValue = JSON.stringify(value)) : (curValue = value);
      formData.append(key, curValue);
    });

    setTimeout(() => {
      setIsLoading(true);
      axios
        .post(`${getBaseUrl()}/api/forms/submit`, formData, {
          headers: { 'Content-Type': 'multipart/form-data' },
        })
        .then(response => {
          console.log(response);
          reset();
          setUserPhoto([]);
          setUserPhotoError('');
          setUserResume([]);
          setUserResumeError('');
          setIsLoading(false);
          openMessage();
          dataLayer.push({ event: 'event-to-ua', eventCategory: 'Form', eventAction: 'Send', eventLabel: 'vacancy' });
        })
        .catch(error => {
          console.log(error.data);
          openErrorMessage();
          setIsLoading(false);
        });
    }, 200);
  };

  return (
    <>
      <Helmet>
        <title>{activeLanguage === 1 ? 'Вакансии | Brasserie Lambic' : 'Vacancy | Brasserie Lambic'}</title>
      </Helmet>
      <div className={classes.features}>
        <div className={classes.feature}>
          <div className={classes.title}>{activeLanguage === 1 ? 'Общие цели' : 'Common goals'}</div>
          <div className={classes.text}>
            <p>
              {activeLanguage === 1
                ? 'Коллектив брассерии «LAMBIC» — это большая и дружная семья, которая живет общими целями и устремлениями. Здесь все сотрудники разделяют ценности компании, поддерживают друг друга, стараются привнести в свой труд творческое начало. У нас нет случайных людей, кто не готов вложить в свою работу сердце и душу.'
                : 'A team of the Brasserie LAMBIC is a large and close family having common goals and endeavours. All our staff members share the companies’ values, support each other, try to bring in creativity. There is no random persons, who are not ready to put their heart and soul into work.'}
            </p>
          </div>
        </div>

        <div className={classes.feature}>
          <div className={classes.title}>{activeLanguage === 1 ? 'Заботимся о сотрудниках' : 'Care for personnel'}</div>
          <div className={classes.text}>
            <p>
              {activeLanguage === 1
                ? 'Со своей стороны, мы стараемся максимально раскрыть индивидуальность и талант каждого сотрудника, обогатить его новыми навыками, создать комфортные условия для работы и уверенность в своей социальной защищенности. Мы убеждены, что, только получая удовольствие от собственного труда, работник может принести реальную пользу компании.'
                : 'For our part, we try to reveal as much as possible an individuality and talent of each employee, develop his or her new skills, create comfortable conditions for work and provide confidence in their social protection. We are convinced that a worker can be really useful for the company, if he or she enjoys his or her work.'}
            </p>
          </div>
        </div>

        <div className={classes.feature}>
          <div className={classes.title}>{activeLanguage === 1 ? 'Лучшие условия' : 'The best conditions'}</div>
          <div className={classes.text}>
            <p>
              {activeLanguage === 1
                ? 'Всем, кто готов стать членом команды ресторана-брассерии «LAMBIC», мы предлагаем обучение профессии, повышение имеющейся квалификации, быстрый карьерный рост, высокий стабильный доход, а для молодежи — возможность совмещения работы с обучением. Мы нацелены на долговременное сотрудничество!'
                : 'To all those who are ready to become a member of the team of the Brasserie-restaurant LAMBIC, we offer professional training, improvement of present qualification, rapid career progression, high and stable income, and for youth the possibility to combine the work with studies. We aim at long-term partnership!'}
            </p>
          </div>
        </div>
      </div>

      <div className={classes.application}>
        <div className={classes.titleRow}>
          <div className={classes.title}>{activeLanguage === 1 ? 'Анкета соискателя' : 'Application form'}</div>
          <div className={classes.text}>
            <span className={classes.note}>{activeLanguage === 1 ? 'Оставить заявку' : 'Leave a request'}</span>
            <a className={classes.link} href='mailto:hr@upstergroup.ru'>
              hr@upstergroup.ru
            </a>
          </div>
        </div>

        <form className={classes.vacancyForm} name='vacancies-app-form' onSubmit={handleSubmit(onSubmit)}>
          <div className={classesForm.inputsRow}>
            <div id='vacancySelectBox' className={`${classesForm.inputBox} ${classesForm.inputBox33}`}>
              <FormSelect
                control={control}
                name='vacancy'
                array={vacanciesOptions}
                register={register('vacancy')}
                defaultValue={vacanciesOptions[0]}
                placeholder={activeLanguage === 1 ? 'Выберите вакансию' : 'Select a vacancy'}
                addClass={classes.vacancySelect}
              />
            </div>
            <div className={classesForm.inputBox}>
              <FormInputText
                placeholder={activeLanguage === 1 ? 'Образование' : 'Education'}
                label={activeLanguage === 1 ? 'Образование' : 'Education'}
                register={register('education')}
                errors={!!errors.education}
                errorLabel={errors?.education?.message}
              />
            </div>
          </div>

          <div className={classesForm.inputsRow}>
            <div className={`${classesForm.inputBox} ${classesForm.inputBox33}`}>
              <FormInputText
                placeholder={activeLanguage === 1 ? 'Знание языков' : 'Languages'}
                label={activeLanguage === 1 ? 'Знание языков' : 'Languages'}
                register={register('languagesSkill')}
                errors={!!errors.languagesSkill}
                errorLabel={errors?.languagesSkill?.message}
              />
            </div>
            <div className={classesForm.inputBox}>
              <FormInputText
                placeholder={activeLanguage === 1 ? 'Опыт работы' : 'Experience'}
                label={activeLanguage === 1 ? 'Опыт работы' : 'Experience'}
                register={register('workExperience')}
                errors={!!errors.workExperience}
                errorLabel={errors?.workExperience?.message}
              />
            </div>
          </div>

          <div className={classesForm.inputsRow}>
            <div className={classesForm.inputBox}>
              <FormInputText
                placeholder={activeLanguage === 1 ? 'Фамилия Имя Отчество' : 'Full name'}
                label={activeLanguage === 1 ? 'Фамилия Имя Отчество' : 'Full name'}
                register={register('FIO')}
                errors={!!errors.FIO}
                errorLabel={errors?.FIO?.message}
              />
            </div>
            <div className={classesForm.inputBox}>
              <FormInputFile
                userFile={userPhoto}
                setUserFile={setUserPhoto}
                userFileError={userPhotoError}
                setUserFileError={setUserPhotoError}
                label={activeLanguage === 1 ? 'Ваше фото' : 'Your photo'}
                type='photo'
                register={register('userPhoto')}
              />
            </div>
            <div className={classesForm.inputBox}>
              <FormInputFile
                userFile={userResume}
                setUserFile={setUserResume}
                userFileError={userResumeError}
                setUserFileError={setUserResumeError}
                label={activeLanguage === 1 ? 'Ваше резюме' : 'Your CV'}
                type='doc'
                register={register('userResume')}
              />
            </div>
          </div>

          <div className={classesForm.inputsRow}>
            <div className={`${classesForm.inputBox} ${classesForm.inputBox33}`}>
              <FormInputPhone
                placeholder={activeLanguage === 1 ? 'Телефон' : 'Phone number'}
                label={activeLanguage === 1 ? 'Телефон' : 'Phone number'}
                register={register('phone')}
                errors={!!errors.phone}
                errorLabel={errors?.phone?.message}
              />
            </div>
            <div className={`${classesForm.inputBox} ${classesForm.inputBox33}`}>
              <FormInputEmail
                placeholder='Email'
                label='Email'
                register={register('email')}
                errors={!!errors.email}
                errorLabel={errors?.email?.message}
              />
            </div>
          </div>

          <div className={classes.submitRow}>
            <button className={classes.submitBtn} type='submit' data-loading={isLoading ? 'true' : 'false'}>
              {activeLanguage === 1 ? 'Отправить' : 'Submit'}
            </button>
            <div className={classes.submitNote}>
              {activeLanguage === 1 ? 'Нажимая на кнопку, вы даете ' : 'By clicking on the button, you consent '}
              <br />
              <Link className={classes.link} to={activeLanguage === 1 ? '/privacy-policy' : '/en/privacy-policy'}>
                {activeLanguage === 1
                  ? 'согласие на обработку своих персональных данных'
                  : 'to the processing of your personal data'}
              </Link>
            </div>
          </div>
        </form>
      </div>

      <MessageModal
        showMessage={showMessage}
        showErrorMessage={showErrorMessage}
        closeMessage={closeMessage}
        message={message}
      />
    </>
  );
}
